module.exports = __webpack_public_path__ + "static/media/mobile.79efb097.svg";